var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDialerHold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 109 109"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 54.5,
    r: 51.5,
    fill: "#FFF",
    stroke: "#999"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#414042",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.25 75.337a20.366 20.366 0 01-14.496-6.004 20.366 20.366 0 01-6.004-14.496 20.366 20.366 0 016.004-14.495 20.366 20.366 0 0114.496-6.005 20.366 20.366 0 0114.496 6.005 20.366 20.366 0 016.004 14.495 20.366 20.366 0 01-6.004 14.496 20.366 20.366 0 01-14.496 6.004zm0-38.842c-10.114 0-18.342 8.228-18.342 18.342 0 10.114 8.228 18.342 18.342 18.342 10.114 0 18.342-8.228 18.342-18.342 0-10.114-8.228-18.342-18.342-18.342z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.934 64.548h-2.158a3.24 3.24 0 01-3.237-3.237V48.364a3.24 3.24 0 013.237-3.237h2.158a3.24 3.24 0 013.237 3.237V61.31a3.24 3.24 0 01-3.237 3.237zm-2.158-17.263a1.08 1.08 0 00-1.079 1.079V61.31a1.08 1.08 0 001.08 1.079h2.157a1.08 1.08 0 001.08-1.08V48.365a1.08 1.08 0 00-1.08-1.08h-2.158zm12.948 17.263h-2.158a3.24 3.24 0 01-3.237-3.237V48.364a3.24 3.24 0 013.237-3.237h2.158a3.24 3.24 0 013.237 3.237V61.31a3.24 3.24 0 01-3.237 3.237zm-2.158-17.263a1.08 1.08 0 00-1.08 1.079V61.31a1.08 1.08 0 001.08 1.079h2.158a1.08 1.08 0 001.079-1.08V48.365a1.08 1.08 0 00-1.08-1.08h-2.157z"
  })))));
}

export default SvgDialerHold;